module.exports = __webpack_public_path__ + "static/media/onboardinstep3.49125ec0.svg";